import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import { Refusal } from "../../workspaces/WorkspaceUi";

// Every reset is confirmed: it says what goes back to its default, and that
// nothing in the content is deleted. A refusal is shown here, where the admin
// acted, and the dialog stays open. Anything else worth a second thought -
// hiding a whole column of types, say - passes its own label and icon.
export default function ConfirmDialog({ open, title, text, confirmLabel, confirmIcon, busy = false, error = "", onConfirm, onClose }) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} PaperProps={{ className: "bfx", sx: { borderRadius: 4, maxWidth: 460 } }}>
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>Nothing in the content is deleted.</DialogContentText>
        {error && <Refusal sx={{ mt: 2 }}>{error}</Refusal>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button variant="contained" startIcon={confirmIcon || <RestartAltRoundedIcon />} onClick={onConfirm} disabled={busy}>
          {busy ? "Working…" : confirmLabel || "Back to the default"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
